"use client";

import { useViewAs } from "@/contexts/view-as-context";

/**
 * Suppresses children when view-as mode is active.
 * Used to hide promotional modals, notifications, and other
 * popups that are irrelevant when impersonating another user.
 */
export function HideInViewAs({ children }: { children: React.ReactNode }) {
  const { isViewAsActive } = useViewAs();
  if (isViewAsActive) return null;
  return children;
}
